// Müşteriler › İşletmeler — API wrapper'ları (M16 T17, spec K16/C9).
// Route'lar: GET/POST /clients/:clientId/entities, PUT .../reorder,
// GET /client-entities/:id/impact, PATCH/DELETE /client-entities/:id, POST .../move-values.

import type { ClientEntity, ClientEntityCreate, ClientEntityUpdate } from "@mahir/shared";
import { api } from "./client";

export interface EntityImpact {
  valueCount: number;
  years: number[];
  childCount: number;
}

export async function listClientEntities(clientId: string): Promise<ClientEntity[]> {
  const res = await api<{ entities: ClientEntity[] }>(`/clients/${clientId}/entities`);
  return res.entities;
}

export async function createClientEntity(
  clientId: string,
  body: ClientEntityCreate,
): Promise<ClientEntity> {
  const res = await api<{ entity: ClientEntity }>(`/clients/${clientId}/entities`, {
    method: "POST",
    body,
  });
  return res.entity;
}

export async function updateClientEntity(
  id: string,
  body: ClientEntityUpdate,
): Promise<ClientEntity> {
  const res = await api<{ entity: ClientEntity }>(`/client-entities/${id}`, {
    method: "PATCH",
    body,
  });
  return res.entity;
}

export async function deleteClientEntity(id: string): Promise<void> {
  await api<void>(`/client-entities/${id}`, { method: "DELETE" });
}

export async function reorderClientEntities(clientId: string, ids: string[]): Promise<void> {
  await api<{ ok: true }>(`/clients/${clientId}/entities/reorder`, {
    method: "PUT",
    body: { ids },
  });
}

export async function getEntityImpact(id: string): Promise<EntityImpact> {
  return api<EntityImpact>(`/client-entities/${id}/impact`);
}

export async function moveEntityValues(
  fromEntityId: string,
  toEntityId: string,
): Promise<{ moved: number }> {
  return api<{ moved: number }>(`/client-entities/${fromEntityId}/move-values`, {
    method: "POST",
    body: { toEntityId },
  });
}
